const steps = [
  { n: '01', title: 'Define the technical challenge', desc: 'We work with your team to scope the problem precisely — separating the engineering question from the organizational one.' },
  { n: '02', title: 'Match the right expertise', desc: 'We identify and engage the specific experts your problem requires, drawing from a vetted international network.' },
  { n: '03', title: 'Vet and coordinate delivery', desc: 'We manage the engagement rigorously — ensuring quality, alignment, and clear communication across all parties.' },
  { n: '04', title: 'Produce decision-ready outcomes', desc: 'Every engagement ends with clear, actionable outputs your organization can act on with confidence.' },
];

export default function HowWeWork() {
  return (
    <section className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-16 mb-16">
          <h2 className="text-3xl md:text-4xl font-700 tracking-tight text-brand-text leading-snug">
            A technical partner<br />with global reach
          </h2>
          <p className="text-brand-text/60 leading-relaxed self-end">
            We identify the right experts, evaluate the problem rigorously, and coordinate execution across organizations, disciplines, and regions.
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8">
          {steps.map(s => (
            <div key={s.n} className="flex flex-col gap-3">
              <span className="text-2xl font-800 text-brand-blue">{s.n}</span>
              <h4 className="text-sm font-600 text-brand-text">{s.title}</h4>
              <p className="text-sm text-brand-text/55 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
